<div class="compare-product-select-wrap">
  <claas-product-compare-select
    class="select-first"
  ></claas-product-compare-select>
  <claas-competitor-compare-select
    class="select-second"
  ></claas-competitor-compare-select>
</div>
